import { motion } from "framer-motion";
import { MessageCircle, ArrowRight, ChevronDown } from "lucide-react";
import { COMPANY_INFO, fadeInUp, staggerContainer } from "../data/constants";

export const HeroSection = () => {
  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center"
      data-testid="hero-section"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-gray-900">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-40"
          style={{
            backgroundImage: `url('/images/hero-banner.png')`,
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900 via-gray-900/95 to-gray-900/70" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <motion.div
            initial="hidden"
            animate="visible"
            variants={staggerContainer}
            className="text-left"
          >
            <motion.span
              variants={fadeInUp}
              className="inline-block bg-orange-500/20 text-orange-400 px-4 py-2 rounded-full text-sm font-semibold mb-6"
            >
              Internet por Fibra Óptica en Tacámbaro
            </motion.span>

            <motion.h1
              variants={fadeInUp}
              className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6"
            >
              La mejor{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600">
                conexión
              </span>{" "}
              para tu hogar y negocio
            </motion.h1>

            <motion.p
              variants={fadeInUp}
              className="text-xl text-gray-300 mb-8 max-w-xl"
            >
              Ofrecemos soluciones de internet de alta velocidad con fibra óptica. 
              Conecta tu hogar, negocio o empresa con la mejor tecnología.
            </motion.p>

            <motion.div variants={fadeInUp} className="flex flex-wrap gap-4">
              <a
                href={COMPANY_INFO.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white px-8 py-4 rounded-full font-semibold text-lg hover:shadow-xl hover:shadow-orange-500/30 transition-all"
                data-testid="hero-cta"
                onClick={() => window.trackEvent && window.trackEvent('click', 'CTA', 'hero_whatsapp_contrata')}
              >
                <MessageCircle className="w-5 h-5" />
                ¡Contrata Ahora!
              </a>
              <a
                href="#paquetes"
                className="inline-flex items-center gap-2 bg-white/10 backdrop-blur text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white/20 transition-all"
                onClick={() => window.trackEvent && window.trackEvent('click', 'Navigation', 'hero_ver_paquetes')}
              >
                Ver Paquetes
                <ArrowRight className="w-5 h-5" />
              </a>
            </motion.div>

            {/* Stats */}
            <motion.div
              variants={fadeInUp}
              className="flex flex-wrap gap-8 mt-12 pt-8 border-t border-white/10"
            >
              <div>
                <div className="text-3xl font-bold text-orange-500">500+</div>
                <div className="text-gray-400">Clientes Satisfechos</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-orange-500">99.9%</div>
                <div className="text-gray-400">Uptime Garantizado</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-orange-500">24/7</div>
                <div className="text-gray-400">Soporte Técnico</div>
              </div>
            </motion.div>
          </motion.div>

          {/* Visual */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="hidden lg:block relative"
          >
            <div className="relative w-full aspect-square">
              <div className="absolute inset-0 bg-gradient-to-br from-orange-500/20 to-transparent rounded-full blur-3xl" />
              <img
                src="/images/fiber-cables.jpg"
                alt="Fiber optic technology"
                className="relative z-10 w-full h-full object-cover rounded-3xl shadow-2xl"
              />
            </div>
          </motion.div>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      >
        <a href="#paquetes" className="flex flex-col items-center text-white/50 hover:text-orange-500 transition-colors">
          <span className="text-sm mb-2">Descubre más</span>
          <ChevronDown className="w-6 h-6 animate-bounce" />
        </a>
      </motion.div>
    </section>
  );
};
